export const API_URL = process.env.REACT_APP_API_URL;
export const API_URL_SQL = process.env.REACT_APP_API_URL_SQL;
export const API_URL_AUTH = process.env.REACT_APP_API_URL_AUTH;
export const API_URL_ESV = process.env.REACT_APP_API_URL_ESV;
export const API_URL_ANGULAR = process.env.REACT_APP_URL_ANGULAR;
export const ENABLE_VERSION_POLLING = process.env.REACT_APP_ENABLE_VERSION_POLLING;
export const automatedServerRoute = process.env.REACT_APP_AUTOMATED_SERVER_ROUTE; // Send Reports Server
export const ESV_PRIVATE_BUCKET = process.env.REACT_APP_S3_ESV_PRIV_BUCKET;
export const AUTOMATION_PRIVATE_BUCKET = process.env.REACT_APP_S3_AUTOMATION_PRIVATE_BUCKET;
export const AUTOMATION_PUBLIC_BUCKET = process.env.REACT_APP_S3_AUTOMATION_PUBLIC_BUCKET;
export const AWS_BASE_PATH = process.env.REACT_APP_S3_BASE_PATH;
